import React from 'react';
import PropTypes from 'prop-types';
import { ReactDataTableTitle, Stack, Typography } from '@metarouter-private/mr-mui';

export default function StatusTableTitle({ writekey = '', cluster }) {
  return (
    <Stack spacing={0}>
      <ReactDataTableTitle label={writekey} noWrap />
      <Typography variant="caption" color="text.secondary" noWrap data-test-id="clusterName">
        {cluster.name}
      </Typography>
    </Stack>
  );
}

StatusTableTitle.propTypes = {
  writekey: PropTypes.string,
  cluster: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};
